import React from "react";
import { useTranslation } from "react-i18next";
import { IoChevronForward } from "react-icons/io5";
import { extractCareerLevelNumber } from "../../utils/helper";

interface CourseCardProps {
  item: any;
  handleNavigateToCourseSessions: (courseId: number) => void;
}

function CourseCard({ handleNavigateToCourseSessions, item }: CourseCardProps) {
  const {
    course_name,
    course_type,
    language,
    creation_date,
    category_type,
    minimum_job_level,
    training_languages_oc,
  } = item;
  const { t } = useTranslation();

  return (
    <>
      <div
        key={item.course_id}
        onClick={() => handleNavigateToCourseSessions(item.course_id)}
        className="flex flex-row w-full justify-between items-center group cursor-pointer"
      >
        {/* <div className="flex flex-col w-full"> */}
        <div className="flex flex-col w-full md:w-1/2">
          {course_name && (
            <p className="text-2xl font-semibold text-[#961e38]">
              {course_name}
            </p>
          )}
          {/* <div className="flex items-center justify-start gap-5 pt-2"> */}
          <div className="flex flex-col md:flex-row items-start justify-start gap-5 pt-2">
            {category_type && (
              <p className="text-xs font-semibold flex items-center justify-start gap-2">
                <span className="text-[#b5b5b5]">{t("Type")}:</span>
                <span>{category_type}</span>
              </p>
            )}

            <p className="text-xs font-semibold flex items-center justify-start gap-2">
              <span className="text-[#b5b5b5]">{t("Lang")}:</span>
              <span>
                {training_languages_oc ? training_languages_oc : t("N/A")}
              </span>
            </p>

            {minimum_job_level && (
              <p className="text-xs font-semibold flex items-center justify-start gap-2">
                <span className="text-[#b5b5b5]">{t("Min Career Lvl")}:</span>
                <span>{extractCareerLevelNumber(minimum_job_level)}</span>
              </p>
            )}
          </div>
        </div>
        <IoChevronForward
          size={40}
          className="text-[#464646] group-hover:text-[#961e38] transition-colors duration-300"
        />
      </div>
      <div className="border border-[#b5b5b5] w-full" />
    </>
  );
}

export default CourseCard;
